import React, { useEffect } from "react";
import { UserContext, OrgContext } from "../contexts";
import Feature from "../feature";
import * as Sentry from "@sentry/react";
import { datadogRum } from "@datadog/browser-rum";

declare var FS: any;

const Tracking: React.FC = () => {
  const { user } = React.useContext(UserContext);
  const { org } = React.useContext(OrgContext);

  useEffect(() => {
    const tierStr = Feature.hasTeamsTier({ org })
      ? Feature.hasTeamsTierTrial({ org })
        ? "teamtrial"
        : "team"
      : "community";
    if (!user) return;
    try {
      FS.identify(user.username, {
        displayName: user.username,
        email: user.email,
        deploymentId_int: org?.id,
        deplyomentName_str: org?.name,
        tier_str: tierStr,
      });
    } catch (err) {
      console.warn(`caught error in tracking script`);
    }
  }, [user, org]);

  useEffect(() => {
    if (!user) return;
    try {
      datadogRum.setUser({
        name: user.username,
        email: user.email,
      });
    } catch (err) {
      console.warn(`caught error in tracking script`);
    }
  }, [user]);

  useEffect(() => {
    if (!org) return;
    try {
      datadogRum.addRumGlobalContext("org", {
        name: org.name,
        id: org.id,
      });
    } catch (err) {
      console.warn(`caught error in tracking script`);
    }
  }, [org]);

  useEffect(() => {
    if (!user) return;
    try {
      Sentry.setUser({ username: user.username, email: user.email });
    } catch (err) {
      console.warn(`caught error in tracking script`);
    }
  }, [user]);

  useEffect(() => {
    if (!org) return;
    try {
      Sentry.setContext("organization", { id: org.id, name: org.name });
    } catch (err) {
      console.warn(`caught error in tracking script`);
    }
  }, [org]);

  return null;
};

export default Tracking;
